import Component from '../abstracts/Component';

export default class ProductScrollComponent extends Component {

  get SELECTORS() {
    return {
      main: '#prd-scroll-carousel',
        card: '.w-p-s__item',
    };
  }
  
  get observedCssClasses (){
      let arr = [
          this.pushDownCardCss,
          this.animateUpCardCss,
          this.fadeOutCardCss
      ];
      return arr;
  }

  constructor() {
    super();
    this.pushDownCardCss = 'down';
    this.animateUpCardCss = 'animated';
    this.fadeOutCardCss = 'fade-out';
  }
  
    initCarousel(){
      let mediaQuery = window.matchMedia('(max-width:991px)');
      let prdCarousel= document.querySelector(this.SELECTORS.main);
      this.moduleLoader.loadCarouselAndExecute(()=>{
          if(mediaQuery.matches){
              
              $(prdCarousel).slick({
                  dots:false,
                  arrows:false,
                  infinite:false,
                  slidesToShow:1,
                  centerMode:false,
                  responsive:[
                      {
                          breakpoint: 767,
                          settings: {
                              centerMode: false,
                              slidesToShow: 1.2
                          }
                      },
                  ]
              });
          }
    
          mediaQuery.addListener((e)=>{
              console.log(e);
              //Until 991px viewport(mobile/tablet-portrait)
              if(e.matches){
                  console.log('is mobile');
                  $(prdCarousel).slick({
                      dots:false,
                      arrows:false,
                      infinite:false,
                      slidesToShow:1,
                      centerMode:false,
                      responsive:[
                          {
                              breakpoint: 767,
                              settings: {
                                  centerMode: false,
                                  slidesToShow: 1.2
                              }
                          },
                      ]
                  });
              } else {
                  $(prdCarousel).slick('unslick');
              }
        
          });
      });
    }
    
    observerCallback(entries){
      let elRatio = .5;
      let cssDownCard = 'down';
      let cssAnimate = 'animated';
      let cssFadeOut = 'fade-out';
      
      for( let entry of entries){
          
          if(entry.boundingClientRect.y >0 && !entry.isIntersecting && entry.intersectionRatio === 0){
              entry.target.classList.add(cssDownCard);
              entry.target.classList.remove(cssAnimate,cssFadeOut);
          }else if(entry.boundingClientRect.y<0||entry.intersectionRatio < elRatio){
              entry.target.classList.add(cssFadeOut);
          }else if(entry.intersectionRatio>elRatio && entry.isIntersecting){
              entry.target.classList.add(cssAnimate);
              entry.target.classList.remove(cssFadeOut);
          }
      }
      
    }
    
    initCardsObserver(){
      let allCards = document.querySelectorAll(this.SELECTORS.card);
      let mqObserver = window.matchMedia('(min-width:992px)');
      let options = {
          threshold:[0,.5,1]
      };
      
      let cardsObserver = new IntersectionObserver(this.observerCallback,options);
      
      if(mqObserver.matches){
          for (let card of allCards){
              cardsObserver.observe(card);
          }
      }
      mqObserver.addListener((e)=>{
          if(e.matches){
              for (let card of allCards){
                  cardsObserver.observe(card);
              }
          }else{
              for (let card of allCards){
                  cardsObserver.unobserve(card);
                  this.resetCard(card);
              }
          }
      })
      
    }
    
    
    resetCard(card){
        card.classList.remove(...this.observedCssClasses);
    }
  render() {
    this.log('Rendering...');
    if(document.querySelectorAll(this.SELECTORS.main)){
      this.initCarousel();
      this.initCardsObserver();
    }
  }
}
